import React from 'react';
import { FaClock, FaPhoneAlt } from 'react-icons/fa';

const PendingApprovalBanner = ({ userName }) => {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="pending-approval-banner">
      <div className="max-w-lg w-full text-center">
        <div className="w-20 h-20 rounded-full bg-amber-500/20 flex items-center justify-center mx-auto mb-6">
          <FaClock className="text-amber-400 text-3xl" />
        </div>
        <h2 className="text-2xl font-bold text-white mb-3">
          Account Pending Approval
        </h2>
        <p className="text-gray-300 text-base leading-relaxed mb-6">
          Welcome, <span className="text-amber-400 font-semibold">{userName || 'there'}</span>! Your account has been created and is currently under review by the administrator.
          Once approved, you will have full access to all features.
        </p>
        <div className="bg-[#0F172A] border border-amber-500/30 rounded-xl p-5">
          <h3 className="text-amber-400 font-semibold text-sm uppercase tracking-wider mb-3">What happens next?</h3>
          <ul className="text-gray-300 text-sm space-y-2 text-left">
            <li className="flex items-start gap-2">
              <span className="text-amber-400 mt-0.5">1.</span>
              <span>Your financial advisor has submitted your details for review.</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-amber-400 mt-0.5">2.</span>
              <span>The Super Admin will verify and approve your account.</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-amber-400 mt-0.5">3.</span>
              <span>You'll receive a notification once your account is approved.</span>
            </li>
          </ul>
        </div>
        <div className="mt-6 flex items-center justify-center gap-2 text-gray-400 text-sm">
          <FaPhoneAlt className="text-xs" />
          <span>Need help? Contact your financial advisor.</span>
        </div>
      </div>
    </div>
  );
};

export default PendingApprovalBanner;
